module.exports = __webpack_public_path__ + "img/dashboard-item.d46fba87.svg";